import { render } from "./Services.vue?vue&type=template&id=59c43b89&scoped=true&ts=true"
import script from "./Services.vue?vue&type=script&lang=ts"
export * from "./Services.vue?vue&type=script&lang=ts"

import "./Services.vue?vue&type=style&index=0&id=59c43b89&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59c43b89"]])

export default __exports__